import React, { Component } from 'react';
import PropTypes from 'prop-types'

import SignUpForm from '../SignUpForm'
import { PootsyTitle } from "../DesignFunctions";
import checkmarkIcon from '../../static/img/checkmark.png'


export default class BookingFlowSignUp extends Component {
	render() {

		let { t } = this.context

		return (
			<div className="booking-flow-sign-up">
				<div className="left">
					<PootsyTitle title={t('signup_header')}/>
					<div className="signup-prompt">
						{t('signup_prompt')}
					</div>
					<div onClick={this.props.onSignInClick} className="login-link">{t('booking_flow_sign_in')}</div>
					<div className="signup-prompt">
						{t('signup_explanation_prompt')}
					</div>
					<div className="checklist">
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_real_time_access')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_updated_statuses')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_communication_system')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_auto_encode_services')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_psv_scanner')}</div>
						<div className="check-item"><img alt="checkmark" src={checkmarkIcon}/>{t('pcla_ios_android')}</div>
					</div>
				</div>
				<div className="right">
					<SignUpForm />
				</div>
			</div>
		)
	}
}

BookingFlowSignUp.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowSignUp.js